<template>
  <component :is="activeComponent"
             @start="startHandler"
             :is-loading="isLoading"
  >
  </component>
</template>

<script setup>
import {computed} from "vue";
import {useFMStore} from "@/store/FMStore";
import Welcome from "@/components/Welcome.vue";
import Selectpostalcode from "@/components/Selectpostalcode.vue";
import Selectaddress from "@/components/Selectaddress.vue";
import Selectdate from "@/components/Selectdate.vue";
import Confirm from "@/components/Confirm.vue";
import Done from "@/components/Done.vue";
defineEmits(['start'])

const FMStore = useFMStore();
const isLoading = ref(false);
const componentMap = {
  Welcome,
  Selectpostalcode,
  Selectaddress,
  Selectdate,
  Confirm,
  Done,
}

const activeComponent = computed(() => {
  return componentMap[FMStore.currentStep] || null
})



async function startHandler() {
  isLoading.value = true
  await FMStore.getPostalCodes()
  FMStore.stepNumber = 1;
  FMStore.goToStep('Selectpostalcode')
  isLoading.value = false
}

</script>